module.exports = __webpack_public_path__ + "static/media/kimkevinlondo03.ae62e939.png";